export const iconFontAwesomeChartsDiagramsDiagramSuccessor = (
	<i className="fa-solid fa-diagram-successor"></i>
);
